var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestimonialIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M54.6094 10.374H33.5156C32.2233 10.374 31.1719 11.4254 31.1719 12.7178V32.6396C31.1719 33.932 32.2233 34.9834 33.5156 34.9834H43.4766V49.0458C43.4766 49.5973 44.1998 49.8393 44.5312 49.3975L56.8359 32.9912C56.912 32.8898 56.9531 32.7664 56.9531 32.6396V12.7178C56.9531 11.4254 55.9018 10.374 54.6094 10.374ZM55.7812 32.4443L44.6484 47.2881V34.3975C44.6484 34.0738 44.3862 33.8115 44.0625 33.8115H33.5156C32.8695 33.8115 32.3438 33.2858 32.3438 32.6396V12.7178C32.3438 12.0716 32.8695 11.5459 33.5156 11.5459H54.6094C55.2555 11.5459 55.7812 12.0716 55.7812 12.7178V32.4443ZM26.4844 10.374H5.39062C4.09828 10.374 3.04688 11.4254 3.04688 12.7178V32.6396C3.04688 33.932 4.09828 34.9834 5.39062 34.9834H15.3516V49.0459C15.3516 49.5942 16.0746 49.8396 16.4062 49.3975L28.7109 32.9912C28.787 32.8898 28.8281 32.7664 28.8281 32.6396V12.7178C28.8281 11.4254 27.7767 10.374 26.4844 10.374ZM27.6562 32.4443L16.5234 47.2881V34.3975C16.5234 34.0738 16.2611 33.8115 15.9375 33.8115H5.39062C4.74445 33.8115 4.21875 33.2858 4.21875 32.6396V12.7178C4.21875 12.0716 4.74445 11.5459 5.39062 11.5459H26.4844C27.1305 11.5459 27.6562 12.0716 27.6562 12.7178V32.4443Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialIcon);
export default __webpack_public_path__ + "static/media/testimonial-icon.ad89b19cb958f106dd8630a7dea9019a.svg";
export { ForwardRef as ReactComponent };